/** POS-I67: serials offered while offline = the cached in-stock ones of the cart's products, minus those in queued sales. */
export function selectOfflineSerials<T extends { id: string; productId: string }>(
  cached: T[] | null | undefined,
  usedSerialIds: string[],
  productIds: string[],
): T[] {
  const used = new Set(usedSerialIds);
  return (cached ?? []).filter((c) => productIds.includes(c.productId) && !used.has(c.id));
}
